import { SummaryStats } from '../components/features/StatsSection/StatsSection.types';
import { AISystemSummaryDto } from '../types/AISystems.types';

export const mapSummaryToStatsSection = (
  summaryData: AISystemSummaryDto
): SummaryStats => {
  const complianceData = {
    compliant: summaryData.compliant,
    inProgress:
      summaryData.byComplianceStatus.find(
        (item) => item.status === 'IN_PROGRESS' || item.status === 'YELLOW'
      )?.count || 0,
    nonCompliant: summaryData.nonCompliant,
  };

  return {
    totalSystems: summaryData.total,
    complianceData,
  };
};
